import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large' | 'sm' | 'md' | 'lg';
  message?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message = 'Loading...',
  className = ''
}) => {
  const { isDark } = useTheme();

  // Support both naming conventions
  const normalizedSize = size === 'sm' ? 'small' : size === 'md' ? 'medium' : size === 'lg' ? 'large' : size;

  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <motion.div
        className={`${sizeClasses[normalizedSize]} relative`}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <div className={`absolute inset-0 rounded-full border-4 ${
          isDark ? 'border-white/20' : 'border-gray-200'
        }`} />
        <div className={`absolute inset-0 rounded-full border-4 border-t-professional-blue-600 ${
          isDark ? 'border-r-transparent border-b-transparent border-l-transparent' : ''
        }`} />
      </motion.div>
      
      {message && (
        <p className={`mt-4 text-sm ${
          isDark ? 'text-slate-400' : 'text-gray-600'
        }`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;